module.exports = __webpack_public_path__ + "img/coverLogo5.bc6550e9.jpg";